import { Box, Tooltip } from "@mui/material";
import { Icon } from "@iconify/react";
import React, { useEffect, useState, useRef } from "react";
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCoordinate,
  updateCoordinate,
} from "../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import { toast } from "react-toastify";
import {updateBoxSize, selectVariable } from "../../../store/reducers/pdfeditor/toolsModificationSlice";
import ToolBarText from "./ToolbarText";
import ToolBarErase from "./ToolbarErase";

function EraseBox({ coordinate, scale, enableDargging, dimensions, isSelected, onSelect,setSelectedBoxId }) {
// function EraseBox({ coordinate, scale, enableDargging, dimensions, clickFlag, setClickFlag }) {
  const nodeRef = useRef(null);
  const dispatch = useDispatch();
  const { currBoxSize, currVariable } = useSelector(
    (state) => state.toolsModification
  );
  console.log("currentVariable in erasebox", currVariable);
  const { fontSize, fontFamily, fontSpace } = useSelector(
    (state) => state.toolsModification
  );

  const [flag, setFlag] = useState(false);
  const [clickFlag, setClickFlag] = useState(false);

  const [dragBoxDetails, setDragBoxDetails] = useState({});
  const [position, setPosition] = useState({
    x: 0,
    y: 0,
    prex: parseInt(coordinate["x-coordinate"]) * scale,
    prey: parseInt(coordinate["y-coordinate"]) * scale,
  });
  const [boxSize, setBoxSize] = useState({
    width: coordinate.width || currBoxSize?.width,
    height: coordinate.height || currBoxSize?.height,
  });

  const widthPdf = dimensions?.width;
  const heightPdf = dimensions?.height;
  useEffect(() => {
    setPosition({
      x: 0,
      y: 0,
      prex: parseInt(coordinate["x-coordinate"]) * scale,
      prey: parseInt(coordinate["y-coordinate"]) * scale,
      // prex: Math.floor(parseInt(coordinate["x-coordinate"]) * scale),
      // prey: Math.floor(parseInt(coordinate["y-coordinate"]) * scale),
    });
  }, [coordinate, scale]);

  const handleSelectBox = (coordinates) => {
    setDragBoxDetails(coordinates);
    dispatch(
      selectVariable({
        variable: coordinates.id,
        fontSize: coordinates?.fontSize,
        width: coordinate.width,
        height: coordinate.height,
        // width: Math.floor(coordinate.width),
        // height: Math.floor(coordinate.height),
        data_type: coordinate?.data_type,
        variableName: coordinates?.value,
        fontFamily: coordinates?.fontFamily,
        fontSpace: coordinates?.fontSpace,
      })
    );
    // setActive(false);
  };
  const handleSelectBoxClick = (coordinates) => {
    setDragBoxDetails(coordinates);
    dispatch(
      selectVariable({
        variable: coordinates.id,
        fontSize: coordinates?.fontSize,
        width: coordinate.width,
        height: coordinate.height,
        // width: Math.floor(coordinate.width),
        // height: Math.floor(coordinate.height),
        data_type: coordinate?.data_type,
        variableName: coordinates?.value,
        fontFamily: coordinates?.fontFamily,
        fontSpace: coordinates?.fontSpace,
      })
    );
  };
//   const handleMouseLeave = () => {
//     // console.log("currVariableeeeeeeeeeee", currVariable);
//     const filterOption = options?.filter(
//       (option) => option.label === selectedVariable
//       // (option) => option.label === currVariable?.variableName
//     );
//     let nested = false;
//     if (filterOption[0]?.value?.values?.length > 0) {
//       nested = true;
//     }

//     if (currVariable?.variableName !== undefined && nested === false) {
//       if (active === false) {
//         dispatch(selectVariable({}));
//         setActive(true);
//       }
//     } else if (currVariable?.variableName?.includes(".") && nested === true) {
//       if (active === false) {
//         dispatch(selectVariable({}));
//         setActive(true);
//       }
//     }
//   };

  const handleStop = (e, data) => {
    const updatedCoordinates = {
      "x-coordinate": (position.prex + data.x) / scale,
      "y-coordinate": (position.prey + data.y) / scale,
      // "x-coordinate": Math.floor((position.prex + data.x) / scale),
      // "y-coordinate": Math.floor((position.prey + data.y) / scale),
    };
    const { width, height } = boxSize || {};
    const xCoord = updatedCoordinates["x-coordinate"] * scale;
    const yCoord = updatedCoordinates["y-coordinate"] * scale;

    // console.log("else xcord and ycord are", xCoord, yCoord, width, height);
    if (
      widthPdf < xCoord + width ||
      widthPdf < 0 ||
      xCoord < 0 ||
        yCoord < 0 ||
      heightPdf < yCoord + height
    ) {
      // toast.error("outside");
      toast.error(
        "Coordinate should stay within the PDF previewer area when dragging."
      );
      // Reset position to prevent moving out of bounds
      setPosition({
        x: 0,
        y: 0,
        prex: parseInt(coordinate["x-coordinate"]) * scale,
        prey: parseInt(coordinate["y-coordinate"]) * scale,
        // prex: Math.floor(parseInt(coordinate["x-coordinate"]) * scale),
        // prey: Math.floor(parseInt(coordinate["y-coordinate"]) * scale),
      });
    } else {
      dispatch(
        updateCoordinate({ id: coordinate.id, newValue: updatedCoordinates })
      );
    }
    onSelect(); // Ensure box is selected on drag stop
  };

  const iconStyle = {
    right: -9,
    zIndex: 3,
    backgroundColor: "transparent",
    padding: "0px",
    width: "14px",
    height: "14px",
    cursor: "pointer",
    position: "absolute",
    left: `${position.prex - 7 + position.x}px`,
    top: `${position.prey - 8 + position.y}px`,
  };

  const handleResizeStop = (e, direction, ref, d) => {
  
    setBoxSize({
      width: boxSize.width + d.width,
      height: boxSize.height + d.height,
    });
    dispatch(
      updateBoxSize({
        width: boxSize.width + d.width,
        height: boxSize.height + d.height,
      })
    );
    let newWidth = boxSize.width + d.width;
    let newHeight = boxSize.height + d.height;
    dispatch(
        updateCoordinate({
          id: coordinate.id,
          newValue: {
            ...coordinate,
            width: newWidth,
            height: newHeight,
          }
        })
      );
   
  };

  const handleDeleteVariable = (id) => {
    dispatch(deleteCoordinate(id));
  };

  return (
    <>
      {
      isSelected &&(
        <ToolBarErase
          style={{...iconStyle, zIndex:12}}
          position={position}
          coordinate={coordinate}

          setSelectedBoxId={setSelectedBoxId}
        />
      )}

      {isSelected ? (
        <Resizable
        style={{
          position: "absolute",
          left: `${position.prex}px`,
          top: `${position.prey}px`,
          textAlign: "center",
          overflow: "hidden",
          textOverflow: "ellipsis",
          transition: "all 0.1s ease-out",
          fontSize: "15px",
          background: "#fff",
          border: "1px dashed #000000",
        }}
        size={{ height: coordinate?.height, width: coordinate?.width }}
        
        onResizeStart={() => {}}
        onResizeStop={handleResizeStop}
        onMouseEnter={() => onSelect()}
        onMouseLeave={() => onSelect()}
        onClick={() => onSelect()}
      >
      </Resizable>
       
      ) : (
        <Draggable
        nodeRef={nodeRef}
        position={position}
        onStop={handleStop}
      >
        <Box
          ref={nodeRef}
          style={{
            position: "absolute",
            left: `${position.prex}px`,
            top: `${position.prey}px`,
            cursor: "move",
            height: coordinate.height,
            width: coordinate.width,
            background:'white',
            textAlign: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            transition: "all 0.1s ease-out",
            border:'1px solid #000000'
          }}
        ></Box>
      </Draggable>
      )}
    </>
  );
}

export default EraseBox;
